<template>
<b-container>

<p class="h5 mb-4">{{pagePrompt}}</p>

<b-row>
  <b-col cols="12" lg="12">
    <BaseSelector v-model="currentlySchooled" 
      :v="$v.currentlySchooled"
      :label="$t('labels.currentlySchooled')"
      :options=yesNoUnknownOptions
      slug="currentlySchooled"/>
  </b-col>
</b-row>

<b-row>
  <b-col cols="12" lg="12">
    <BaseSelector v-model="schoolPrior" 
      :v="$v.schoolPrior"
      :label="$t('labels.schoolPrior')"
      :options=yesNoUnknownOptions
      slug="schoolPrior"/>
  </b-col>
</b-row>

<div v-if="currentlySchooled === 'Y' || schoolPrior === 'Y'" >

  <b-row v-if="false">
    <b-col>
      <BaseRadioInput v-model="requestExclusionLetter"
                          :v="$v.requestExclusionLetter"
                          :label="$t('labels.requestExclusionLetter')"
                          :options=yesNoOptions
                          slug="requestExclusionLetter"/>
    </b-col>
  </b-row>

  <p v-if="requestExclusionLetter === 'Y'" v-show="false">{{emailPrompt}}</p>

  <b-button v-if="schoolPrior === 'Y'" v-b-modal.modal-school variant="primary" style="margin-bottom:20px;" @click="school.type = 'SH'">{{$t('schoolPage.school')}}</b-button>
  <b-button v-if="schoolPrior === 'Y'" v-b-modal.modal-school variant="primary" style="margin-bottom:20px;" @click="school.type = 'CC'">{{$t('schoolPage.childcare')}}</b-button>
  <b-button v-if="currentlySchooled === 'Y'" v-b-modal.modal-school variant="primary" style="margin-bottom:20px;" @click="school.type = 'UN'">{{$t('schoolPage.college')}}</b-button>

    <b-list-group>
      <b-list-group-item class="d-flex justify-content-between align-items-center"
        v-for="(school, idx) in schools" v-bind:key="idx">
        {{school.tempName}} {{school.schoolName}} {{school.schoolInfo}} {{school.schoolDescription}}
        <b-button v-if="false" variant="primary" size="sm" @click="edit(idx)">Edit</b-button>
      </b-list-group-item>
    </b-list-group>
</div>

    <b-modal id="modal-school" size="lg" hide-header hide-footer scrollable >
      <h2>{{headerTitle}}</h2>
      <hr/>
      <form ref="form" @submit.prevent="save">
        <div v-show="school.type === 'SH'">
          <b-row>
            <b-col cols="12">
              <BaseK12SchoolSelector v-model="k12Obj" 
                :v="$v.k12Obj"
                :label="$t('labels.school-location')"
                slug="schoolLocaion"
                :tip="$t('tips.otherSelection')"/>
            </b-col>
          </b-row>
          <b-row v-if="k12Obj && k12Obj.value === 'OTHER'">
            <b-col cols="12">
              <BaseTextInput v-model="school.schoolNameOther" 
                :v="$v.school.schoolNameOther"
                :label="$t('labels.pleaseSpecify')"
                slug="schoolNameOther"/>
            </b-col>
          </b-row>          
          <b-row>
            <b-col cols="12">
              <BaseRadioInput v-model="school.attendedInfectious"
                                :v="$v.school.attendedInfectious"
                                :label="infectiousLabel"
                                :options=yesNoOptions
                                slug="attendedInfectious"/>
            </b-col>
           </b-row>
           <b-row>
            <b-col cols="12">
              <BaseRadioInput v-model="school.schoolShare" 
                                :v="$v.school.schoolShare"
                                :label="$t('labels.school-share')"
                                :options=yesNoOptions
                                slug="schoolShare"/>
            </b-col>
            </b-row>
          </div>

        <div v-show="school.type === 'CC'">
          <b-row>
            <b-col cols="12">
              <BaseChildCareSelector v-model="ccObj" 
                :v="$v.ccObj"
                :label="$t('labels.cc-name')"
                slug="ccShool"
                :tip="$t('tips.otherSelection')"/>
            </b-col>
          </b-row>
          <b-row v-if="ccObj && ccObj.value === 'DAY_0000'">
            <b-col cols="12">
              <BaseTextInput v-model="school.schoolNameOther" 
                :v="$v.school.schoolNameOther"
                :label="$t('labels.pleaseSpecify')"
                slug="schoolNameOtherCC"/>
            </b-col>
          </b-row>          

          <b-row>
            <b-col cols="12">
              <BaseRadioInput v-model="school.attendedInfectious"
                                :v="$v.school.attendedInfectious"
                                :label="infectiousLabel"
                                :options=yesNoOptions
                                slug="ccAttendedInfectious"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <BaseRadioInput v-model="school.schoolShare" 
                                :v="$v.school.schoolShare"
                                :label="$t('labels.school-share')"
                                :options=yesNoOptions
                                slug="ccShare"/>
            </b-col>
            </b-row>
          </div>
          
          <div v-show="school.type === 'UN'">
              <b-row>
                  <b-col cols="12">
                      <BaseSchoolSelector v-model="school.sn"
                          :v="$v.school.sn"
                          :label="$t('labels.uc-nameOfSchool')"
                          slug="uc-schoolName"
                          :tip="$t('tips.otherSelection')"/>
                  </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <BaseTextInput v-model="school.schoolNameOther" v-if="school.sn && school.sn.code === 'OTHER'"
                                :v="$v.school.schoolNameOther"
                                :label="$t('labels.uc-othername')"
                                slug="ucOtherName"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <BaseRadioInput v-model="school.classType" 
                            :v="$v.school.classType"
                            :label="$t('labels.uc-classtype')"
                            :options=classTypeOptions
                            slug="ucClassType"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                    <BaseTextInput v-model="school.infectiousClasses" v-if="school.classType === 'INPERSON' || school.classType === 'BOTH'"
                        :v="$v.school.infectiousClasses"
                        :label="$t('labels.uc-infectiousClasses')"
                        slug="ucInfectiousClasses"/>
                  </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <BaseRadioInput v-model="school.campusLiving" 
                            :v="$v.school.campusLiving"
                            :label="$t('labels.uc-campusLiving')"
                            :options=campusLivingOptions
                            slug="ucCampusLiving"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                    <BaseTextInput v-model="school.buildingName" v-if="school.campusLiving === 'DORM'"
                        :v="$v.school.buildingName"
                        :label="$t('labels.uc-buildingName')"
                        slug="ucBuildingName"/>
                  </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <BaseMultiCheckboxInput v-model="campusActivitySelection" :v="$v.campusActivitySelection"
                      :label="$t('labels.uc-campusActivity')"
                      :options="campusActivityOptions"
                      slug="ucCampusActivity"/>  
                </b-col>
              </b-row>
              <b-row>
                          <b-col cols="12">
              <BaseRadioInput v-model="school.schoolShare"
                                :v="$v.school.schoolShare"
                                :label="$t('labels.school-share')"
                                :options=yesNoOptions
                                slug="ccShare"/>
            </b-col>
            </b-row>

         </div>



        <b-row>
          <b-col>
            <b-button @click="close" style="margin-right:15px;">{{$t('buttons.cancel')}}</b-button>
            <b-button type="submit" variant="primary" :disabled="$v.school.$invalid">{{$t('buttons.save')}}</b-button>
          </b-col>
        </b-row>

      </form>
    </b-modal>


</b-container>

</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import moment from 'moment'
import _ from "lodash"
import i18n from '@/i18n'

export default {
    mixins: [
       commonOptions
    ],
  props: {
    symptoms: [Object],
    exclusionLetter: String,
    email: String
  },
  data: () => ({
    schoolPrior: null, 
    currentlySchooled: null,
    requestExclusionLetter: '',
    schools: [ ],
    campusActivitySelection: [ ],
    editedIndex: -1,
    k12Obj: {},
    k12OtherName: '',
    ccObj: {},
    school: {
      sn: {
        code: '',
        description: '',
      },
      type: '',
      schoolName: '',
      schoolInfo: '',
      attendedInfectious: '',
      schoolShare: '',
      schoolNameOther: '',
      classType: '',
      infectiousClasses: '',
      campusLiving: '',
      buildingName: '',
      campusActivity: '',
      tempName: ''
    },

    defaultItem: {
      sn: {
        code: '',
        description: '',
      },
      type: '',
      schoolName: '',
      schoolInfo: '',
      attendedInfectious: '',
      schoolShare: '',
      schoolNameOther: '',
      classType: '',
      infectiousClasses: '',
      campusLiving: '',
      buildingName: '',
      campusActivity: '',
      tempName: '',
    },
  }),

  computed: {
    _() {
      return this._
    },
    headerTitle() {
      if (this.school.type === 'SH') {
        return this.$i18n.t('schoolPage.school', this.$root.$i18n.locale)
      }
      if (this.school.type === 'CC') {
        return this.$i18n.t('schoolPage.childcare', this.$root.$i18n.locale)
      }
      if (this.school.type === 'UN') {
        return this.$i18n.t('schoolPage.college', this.$root.$i18n.locale)
      }
      return 'School'
    },
    pagePrompt() {
      var exposePeriodStart
      if (this.symptoms.covidSymptoms === 'Y') {
        var startDate = moment(this.symptoms.covidSymptomsStart)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else if (this.symptoms.covidLastTested !== '') {
        startDate = moment(this.symptoms.covidLastTested)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else {
        exposePeriodStart = moment().subtract(2, 'days').format('MM/DD/YYYY')
      }

      return this.$i18n.t('schoolPage.pagePrompt', this.$root.$i18n.locale, {date: exposePeriodStart})
    },
    infectiousLabel() {
      var exposePeriodStart
      if (this.symptoms.covidSymptoms === 'Y') {
        var startDate = moment(this.symptoms.covidSymptomsStart)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else if (this.symptoms.covidLastTested !== '') {
        startDate = moment(this.symptoms.covidLastTested)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else {
        exposePeriodStart = moment().subtract(2, 'days').format('MM/DD/YYYY')
      }

      return this.$i18n.t('schoolPage.infectiousLabel', this.$root.$i18n.locale, {date: exposePeriodStart})
    },
    
    emailPrompt() {
      return this.$i18n.t('workPage.emailPrompt', this.$root.$i18n.locale, {email: this.email})
    },
  },
  
  watch: {

    exclusionLetter: function() {
      this.requestExclusionLetter = this.exclusionLetter
    },

    k12Obj: function() {
        if (this.k12Obj && this.k12Obj.value) {
          this.school.sn.code =  this.k12Obj.value
          this.school.sn.description = this.k12Obj.text
          this.school.tempName =  this.k12Obj.text
          this.school.name = this.k12Obj.text
        } else {
          this.school.sn.code = ''
          this.school.sn.description = ''
        }
    },

    ccObj: function() {
        if (this.ccObj && this.ccObj.value) {
          this.school.sn.code =  this.ccObj.value
          this.school.sn.description = this.ccObj.text
          this.school.tempName =  this.ccObj.text
          this.school.name = this.ccObj.text
        } else {
          this.school.sn.code = ''
          this.school.sn.description = ''
        }
    },

  },

  validations() {
    return {
      requestExclusionLetter: { required: false },
      schoolPrior: { required : false },
      currentlySchooled: { required: false }, 
      k12Obj: { required: false },
      k12OtherName: { requied : false, maxLength: maxLength(100)},
      ccObj: { required: false },
      school: {
        sn: {
        code: { required: false},
        description: { required: false },
      },
        type: { required },
        schoolName: {required: false},
        schoolInfo: {required: false},
        attendedInfectious: {required: false},
        schoolShare: {required: false},
        schoolNameOther: {required: false, maxLength: maxLength(100)},
        classType: {required: false},
        infectiousClasses: {required: false},
        campusLiving: {required: false},
        buildingName: {required: false},
        campusActivity: {required: false},
      },
      campusActivitySelection: { required: false },
      form: [ ]
    }
  },
  methods: {
    close () {
        this.$bvModal.hide('modal-school')
        setTimeout(() => {
          this.school = Object.assign({}, this.defaultItem)
          this.k12Obj =  {}
          this.campusActivitySelection = [ ]
          this.editedIndex = -1
          this.$nextTick(() => { this.$v.school.$reset() })
        }, 300)
      },

      save () {
          this.school.campusActivity = this.campusActivitySelection.join()

          if (this.school.type === 'UN') {
            this.school.schoolName = this.school.sn.code
            this.school.schoolDescription = this.school.sn.description
            this.school.tempName = this.school.schoolNameOther
          }
          if (this.school.type === 'SH') {
            this.school.schoolName = this.school.sn.code
            if (this.school.schoolName === 'OTHER') {
              this.school.schoolDescription = this.schoolNameOther
              this.school.tempName = this.school.schoolNameOther
            } else {
              this.school.schoolDescription = this.school.sn.description
            }
          }
          if (this.school.type === 'CC') {
            this.school.schoolName = this.school.sn.code
            this.school.schoolDescription = this.school.sn.description
            this.school.tempName = this.school.schoolNameOther
          }

        if (this.editedIndex > -1) {
            Object.assign(this.schools[this.editedIndex], this.school)
        } else {            
            this.schools.push(this.school)
        }

        this.k12Obj = {}
        this.ccObj = {}
        console.log(this.schools)
        this.close()
      },

      edit (idx) {
        this.editedIndex = idx
        this.school = Object.assign({}, this.schools[idx])
        if (this.school.campusActivity) {
          this.campusActivitySelection = this.school.campusActivity.split(',')
        }
        this.school.sn = {
          code: this.school.schoolName,
          description: this.school.schoolDescription
        }
        this.$bvModal.show('modal-school')
      },

      validate() {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data, isValid)
        return isValid
      }
  }
}
</script>

<style>

</style>
